import ProgressLinear from './ProgressLinear.vue'
import ProgressCircular from './ProgressCircular.vue'

export default {
  ProgressLinear,
  ProgressCircular
}



// WEBPACK FOOTER //
// ./src/components/progress/index.js